import { FC } from 'react';
import { Button, Modal } from 'shared';

type Props = {
  title?: string;
  message?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  hideConfirmBtn?: boolean;
};

export const ConfirmationModal: FC<Props> = ({ title, message, onConfirm, onCancel, isSubmitting, hideConfirmBtn }) => (
  <Modal
    isOpen
    onClose={onCancel}
    title={title}
    size="md"
    footer={
      <div className="d-flex gap-3">
        {!hideConfirmBtn && <Button text="Confirm" variant="primary" onClick={onConfirm} isLoading={isSubmitting} />}
        <Button text="Cancel" variant="light-primary" onClick={onCancel} />
      </div>
    }
  >
    <div className="fs-3">{message}</div>
  </Modal>
);
